import fetch from 'cross-fetch';
import qs from 'query-string';
import CustomError from './CustomError';
import {
  NETWORK_REQUEST_FAILED,
  NETWORK_ERROR,
  UNEXPECTED_ERROR,
  AUTH_ERROR,
  GATEWAY_TIMEOUT_ERROR,
  REQUEST_TIMEOUT_ERROR
} from '../constants/services';

const HTTP_ERROR_MAP = {
  401: AUTH_ERROR,
  408: REQUEST_TIMEOUT_ERROR,
  504: GATEWAY_TIMEOUT_ERROR
};

const buildHttpError = (status) =>
  HTTP_ERROR_MAP[status] ?? { code: status, message: `HTTP Error ${status}` };

export default async function fetchWrapper(rawUrl, rawOptions = {}) {
  try {
    const params = rawOptions.params ? rawOptions.params : null;
    const queryParams = params ? `?${qs.stringify(params)}` : '';
    const url = rawUrl + queryParams;
    const options = {
      method: rawOptions.method,
      headers: {
        Authorization: `Bearer ${rawOptions.token}`,
        Accept: 'application/json',
        ...rawOptions.headers
      },
      body: rawOptions.body,
      signal: rawOptions.signal
    };

    const query = await fetch(url, options);
    if (!query.ok) {
      const transactionId = query.headers.get('transactionId');
      const endpoint = query.url;
      const json = await query.json().catch(() => ({}));
      const httpError = buildHttpError(query.status);
      const errorPayload = HTTP_ERROR_MAP[query.status]
        ? { ...httpError, transactionId, endpoint }
        : { ...httpError, ...json, transactionId, endpoint };
      throw new CustomError(errorPayload);
    }
    return query;
  } catch (error) {
    if (error instanceof CustomError) {
      throw error;
    }
    if (error.message === NETWORK_REQUEST_FAILED) {
      throw new CustomError(NETWORK_ERROR);
    }
    // log error here
    throw new CustomError(UNEXPECTED_ERROR);
  }
}
